import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SSRIcon from '@ingka/ssr-icon';
import { questionMarkCircle } from '@ingka/ssr-icon/icons';
import { Report } from 'core/slices/models';
import './GridReportHeader.scss';

interface GridReportHeaderProps {
  activeReport: Report;
}

export const GridReportHeader: React.FC<GridReportHeaderProps> = ({
  activeReport,
}) => {
  if (!activeReport) return null;
  return (
    <Row className="report-header sticky">
      <Col sm={10}>
        <div className="report-name">{activeReport?.name}</div>
      </Col>
      {activeReport?.helpUrl ? (
        <Col
          sm={2}
          className="report-help text-end report-help-link"
          onClick={() =>
            window.open(activeReport.helpUrl, '_blank', 'noopener,noreferrer')
          }
          style={{ cursor: 'pointer' }}
        >
          <span className="report-help-icon">
            <SSRIcon paths={questionMarkCircle} style={{ color: 'white' }} />
          </span>
          About this report
        </Col>
      ) : (
        <Col sm={2} className="report-help text-end">
          <span className="report-help-icon">
            <SSRIcon paths={questionMarkCircle} style={{ color: 'white' }} />
          </span>
          About this report
        </Col>
      )}
    </Row>
  );
};
